import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerCampaignService } from '../../../../services/customer-campaign.service';
import { KeywordConfig } from '../../../../shared/models/keywords/keywords';

@Component({
  selector: 'app-components-shared-campaign-summary',
  templateUrl: './campaign-summary.component.html',
  styleUrls: ['../customer-campaign/customer-campaign.component.scss']
})
export class CampaignSummaryComponent {

  @Input() customer: Boo.Objects.Customer;
  @Input() websiteUrls: Boo.Objects.WebsiteUrl[];
  @Input() trackingKeywords: Boo.Objects.WebsiteKeywordTracking[];
  @Input() restrictions: Boo.Objects.CustomerCampaign.Enums.RestrictionTypes[];
  @Input() keywordConfig: KeywordConfig;
  @Output() updateKeywordConfig = new EventEmitter();

  customerCampaignRestrictionTypes_ReadOnly = Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.ReadOnly;
  customerCampaignRestrictionTypes_DisableCustomerCampaignType = Boo.Objects.CustomerCampaign.Enums.RestrictionTypes.DisableCustomerCampaignType;

  constructor(
    private customerCampaignService: CustomerCampaignService) { }

  campaignTypeChanged(): void {
    this.updateKeywordConfig.emit();
  }

  get pageCount(): number {
    return this.websiteUrls ? this.websiteUrls.filter(url => this.isActiveStatus(url)).length : 0;
  }

  get keywordCount(): number {
    return this.websiteUrls ? this.websiteUrls.filter(url => this.isActiveStatus(url)).flatMap(x => x.Keywords).filter(x => x.IsActive).length : 0;
  }

  get trackingCount(): number {
    return this.trackingKeywords ? this.trackingKeywords.filter(x => x.IsActive && !x.WasFirstPage).length : 0;
  }

  private isActiveStatus(websiteUrl: Boo.Objects.WebsiteUrl): boolean {
    return this.customerCampaignService.isActiveStatus(websiteUrl);
  }
}
